import {
  getMaterieelPaneelUrl,
  mapMaterieelPaneel,
  type MaterieelPaneelResponse,
} from '@/queries/materieelpaneel/materieelPaneelApi';
import { useFetchWithAuth } from '@/queries/useFetchWithAuth';
import useClientState from '@/state/useClientState';
import { useQuery } from '@tanstack/react-query';

export type { MaterieelEigenschappen } from '@/queries/materieelpaneel/materieelPaneelApi';
export { formatNumber } from '@/queries/materieelpaneel/materieelPaneelApi';

const REFETCH_INTERVAL_MS = 10_000;

export const useMaterieelEigenschappen = (overrideEenheidsnummer?: string) => {
  const materieelPanelData = useClientState((state) => state.materieelPanelData);
  const stateEenheidsnummer = useClientState((state) => state.materieelPanelData?.nummer);
  const showMaterieelPanel = useClientState((state) => state.showMaterieelPanel);
  const { fetchWithAuth } = useFetchWithAuth();

  const eenheidsnummer = overrideEenheidsnummer ?? stateEenheidsnummer;
  const isOverride = !!overrideEenheidsnummer;

  const { data: eigenschappen } = useQuery({
    queryKey: ['materieelPaneel', eenheidsnummer],
    queryFn: async ({ signal }) => {
      const response = await fetchWithAuth(getMaterieelPaneelUrl(eenheidsnummer!), { signal });
      if (response.status > 499) {
        throw new Error(`Applicatiefout ${response.status}: ${response.statusText}`);
      } else if (!response.ok) {
        return null;
      }
      const json: MaterieelPaneelResponse = await response.json();
      return mapMaterieelPaneel(json);
    },
    enabled: !!eenheidsnummer && eenheidsnummer !== 'MANCO' && (isOverride || showMaterieelPanel),
    refetchInterval: REFETCH_INTERVAL_MS,
  });

  return { eigenschappen, materieelPanelData };
};
